module.exports = __webpack_public_path__ + "resources/img/NHNcloud_thumb.fb93679971f81b1a4cc4d6785ad4af87.png";